import { lazy } from "react";

const RELOAD_KEY = "pp_stale_chunk_reload_at";
const RELOAD_WINDOW_MS = 60000;

export const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" ||
  /Loading (CSS )?chunk [\w-]+ failed/i.test(error?.message || "");

const claimReload = () => {
  if (typeof navigator !== "undefined" && navigator.onLine === false) return false;
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < RELOAD_WINDOW_MS) return false;
    window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    return true;
  } catch {
    return false;
  }
};

export const loadWithReload = (factory, reload = () => window.location.reload()) =>
  factory().catch((error) => {
    if (!isChunkLoadError(error) || !claimReload()) throw error;
    reload();
    return new Promise(() => {});
  });

const lazyWithReload = (factory) => lazy(() => loadWithReload(factory));

export default lazyWithReload;
